import styled from 'styled-components';

export const ModalContainer = styled.div`
  position: fixed;
  inset: 0;

  z-index: 2000;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: var(--space-l);

  background: rgba(0, 0, 0, 0.55);

  .modal {
    position: relative;

    width: min(100%, 760px);

    max-height: 88vh;

    overflow-y: auto;

    background: linear-gradient(180deg, var(--offWhite) 0%, var(--white) 100%);

    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 28px;

    box-shadow:
      0 28px 70px rgba(0, 0, 0, 0.18),
      0 6px 18px rgba(0, 0, 0, 0.08);

    padding: var(--space-xxxl);

    animation: swing-in-top-fwd 0.45s cubic-bezier(0.175, 0.885, 0.32, 1.1);

    scrollbar-width: thin;
  }

  .content {
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;

    gap: var(--space-m);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    text-align: center;
  }

  button {
    min-width: 150px;
  }

  .buttonGroup {
    width: 100%;

    display: flex;
    justify-content: center;
  }

  .closeButton {
    position: absolute;

    top: 18px;
    right: 18px;

    width: 40px;
    min-width: 40px;
    max-width: 40px;

    height: 40px;
    min-height: 40px;

    padding: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 50%;

    background: rgba(255, 255, 255, 0.92);

    color: var(--grey4);

    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1;

    cursor: pointer;

    flex-shrink: 0;

    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);

    transition:
      background-color 0.2s ease,
      color 0.2s ease,
      border-color 0.2s ease,
      transform 0.2s ease;

    &:hover {
      background: rgba(255, 210, 107, 0.14);

      color: var(--orange5);

      border-color: rgba(242, 175, 23, 0.2);

      transform: rotate(90deg);
    }
  }

  @keyframes swing-in-top-fwd {
    0% {
      transform: translateY(-24px) scale(0.96);
      opacity: 0;
    }

    100% {
      transform: translateY(0) scale(1);
      opacity: 1;
    }
  }

  @media screen and (max-width: 768px) {
    padding: var(--space-m);

    .modal {
      width: 100%;

      max-height: 90vh;

      padding: var(--space-xxl);
      border-radius: 24px;
    }
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-s);

    .modal {
      padding: var(--space-xl);
      border-radius: 20px;
    }

    .closeButton {
      top: 14px;
      right: 14px;

      width: 38px;
      height: 38px;

      font-size: 1.3rem;
    }

    input {
      width: 100%;
      min-width: 0;
    }

    button {
      width: 100%;
      min-width: 0;
    }
  }

  @media screen and (max-width: 430px) {
    .modal {
      padding: var(--space-l);
      border-radius: 18px;
    }
  }
`;
